import * as React from 'react';

import MarkdownEditorModal from 'components/common/MarkdownEditor/EditorModal';
import { useModalContext } from 'security-app/components/common/Modal/ModalContext';
import { useUpdateSecurityEvent } from 'security-app/hooks/useSecurityEventsAPI';

function NotesModal() {
  const { entity: securityEvent, setEntity, setModal } = useModalContext();
  const { updateSecurityEvent } = useUpdateSecurityEvent();

  const onConfirm = async () => {
    const payload = {
      owner: securityEvent.owner,
      notes: securityEvent.notes,
      status: securityEvent.status,
    };

    await updateSecurityEvent({ id: securityEvent.event_id, data: payload });

    setModal(null);
    setEntity(null);
  };

  const onCancel = () => {
    setModal(null);
    setEntity(null);
  };

  const handleNoteChange = (newValue: string) => {
    setEntity({ ...securityEvent, notes: newValue });
  };

  return (
    <MarkdownEditorModal show
                         value={securityEvent.notes}
                         onChange={handleNoteChange}
                         onClose={onCancel}
                         onDone={onConfirm} />
  );
}

export default NotesModal;
